export enum StockKeepingUnitRejectionReasons {
  DAMAGED_GOODS = 'damaged-goods',
  GOODS_REFUSED = 'goods-refused',
  PRODUCT_NOT_AVAILABLE = 'product-not-available',
  SHORTAGE = 'shortage',
  LATE_TO_DELIVERY = 'late-to-delivery',
  RTW_DRIVER_OUT_OF_HOURS = 'rtw-driver-hours',
  OTHER = 'other',
}

export enum StockKeepingUnitOveragesReasons {
  OVER_ORIGINAL_ORDERED_QUANTITY = 'over-original-ordered-quantity',
  OTHER = 'other',
}

export enum StockKeepingUnitStatus {
  DELIVERED = 'delivered',
  REJECTED = 'rejected',
}
